import { Rating as ReactRating } from "@smastrom/react-rating";

import type { IRatingProps } from "@/components/atoms/Rating/types";

const Rating = ({ ...props }: IRatingProps) => {
  return <ReactRating className="star-app-store" {...props} />;
};

export default Rating;
